import { makeAction, makeReducer } from '@finn-no/redux-actions';

import type { HotelResponse } from '../interfaces';
import defaultState from './defaultState';

export const actions = {
    setHotel: makeAction<HotelResponse>('HOTEL', (_, action) => ({ ...defaultState.hotel, ...action.payload })),
};

export default actions;
export const hotelReducer = makeReducer<HotelResponse>(actions);
